// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__w4Xf7","header":"ReportDetails_header__2Uh1P","title":"ReportDetails_title__1joRA","left":"ReportDetails_left__3Klz7"};